export default function authHeader() {
	let user = JSON.parse(localStorage.getItem("user"));

	if (user && user.accessToken) {
		/* return { Authorization: 'Bearer ' + user.accessToken }; */
		// for Node.js Express back-end
		return {
			"Content-type": "application/json",
			"x-access-token": user.accessToken,
		};
	} else {
		return {};
	}
}
